var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0237732,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 0 0.0237732)",
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1329_4907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9944 15.9166L22.0542 8L22.0542 13.7964L14.1711 19.5995L22.0542 19.6062L22.0542 23.83L29.9944 15.9166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15.9133L9.94019 23.8266L9.94019 18.0773L17.8232 12.2271L9.94019 12.2204L9.94019 8L2 15.9133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1329_4907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 16.129,
    fill: "white",
    transform: "translate(2 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZk);
export default __webpack_public_path__ + "static/media/ZK.e52da7c6b074a1752aa7c35e10d1d73c.svg";
export { ForwardRef as ReactComponent };